import styled from 'styled-components'

import Button from '../../../../../../shared/components/Button'

export const ContainerForm = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;

  input {
    width: 40vw;
    max-width: 420px;
    min-width: 513px;
  }

  button {
    margin-top: 20px;
  }
`
export const Container = styled.div`
  width: 100vw;
  display: flex;

  flex: 1;

  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  input {
    width: 40vw;
    max-width: 513px;
  }
`
export const StyledButton = styled(Button)`
  position: absolute;
  bottom: 20px;

  @media (max-width: 1377px) {
    position: relative;
    bottom: -150px;
  }

  @media (max-height: 668px) {
    bottom: -120px;
  }
`
